import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { KycService } from '../../../../../../shared/services/kyc.service';
import { ToastrService } from 'ngx-toastr';

export interface KycImageModel {
    name: string;
    value: string;
    type: 'image';
    file: any;
}

@Component({
    selector: 'app-kyc-image',
    templateUrl: './image.component.html',
    styleUrls: ['./image.component.scss'],
})
export class ImageComponent implements OnInit {
    @Input() input: KycImageModel;

    @Output() keyUp = new EventEmitter<{}>();
    fileName: string;
    file: FileList;
    picture: any;
    url: string;
    userId: any;

    constructor(private api: KycService, private toastr: ToastrService) {}

    ngOnInit() {
        this.api.getProfile().subscribe((res: any) => {
            this.userId = res.data.userId;
        });
    }

    emitInput(e) {
        const file = e.target.files[0];
        this.fileName = file.name;
        this.keyUp.emit({
            name: this.input.value,
            value: file,
        });

        //upload image
        let uploaddata = new FormData();

        uploaddata.append('file', file);
        uploaddata.append('uploadType', this.input.value);
        uploaddata.append('userId', this.userId);
        uploaddata.append('productType','ADVISORY');

        this.api.updateImageKYC(uploaddata).subscribe(
            (res) => {
                if (res) {
                    this.toastr.info(
                        'Image upload successful !',
                        'Upload Success!',
                        {
                            positionClass: 'toast-top-center',
                            timeOut: 2000,
                        }
                    );
                }
            },
            (err) => {
                this.toastr.error(
                    'Image upload unsuccessful!',
                    'Something went wrong!',
                    {
                        positionClass: 'toast-top-center',
                        timeOut: 2000,
                    }
                );
            }
        );
    }
}
